<template>
    <div class="gst-header__content bg-primary">
        <h1>{{ $t('title') }}</h1>
    </div>
</template>

<script>
export default {
    name: 'Header',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'layouts.default.header',
    },
};
</script>

<style lang="scss">
@import '@scssVariables';

.gst-header__content {
    padding: theme-spacing(4);
    color: theme-color('white');
    height: 112px;
    display: flex;
    align-items: flex-end;
}
</style>
